<div id="todo" class="page-layout carded left-sidebar inner-scroll">


    <!-- SIDEBAR -->
    <fuse-sidebar class="sidebar" name="customer-main-sidebar" position="left" lockedOpen="gt-md">
        <customer-main-sidebar></customer-main-sidebar>
    </fuse-sidebar>
    <!-- / SIDEBAR -->

    <!-- CENTER -->
    <div class="center">

        <div class="content-card" style="overflow-y: scroll;">
<!-- CONTENT -->
<div id="ngx-datatable" class="page-layout simple fullwidth docs">
    <div class="content p-24">
        <input
                autofocus
                type="text"
                style="padding:8px;margin:15px auto;width:30%;"
                placeholder="{{ 'Type to filter customers list...'|translate }}"
                (input)="updateFilter($event)"
        />

        <div class="registration-source-filters">
            <button
                class="filter-btn"
                [class.active]="selectedRegistrationSource === null"
                (click)="filterByRegistrationSource(null)">
                {{ 'All'|translate }}
            </button>
            <button
                class="filter-btn filter-btn-manager"
                [class.active]="selectedRegistrationSource === 'manager'"
                (click)="filterByRegistrationSource('manager')">
                {{'Manager'|translate}}
            </button>
            <button
                class="filter-btn filter-btn-internet"
                [class.active]="selectedRegistrationSource === 'internet_shop'"
                (click)="filterByRegistrationSource('internet_shop')">
                {{'Internet Shop'|translate}}
            </button>
            <button
                class="filter-btn filter-btn-mobile"
                [class.active]="selectedRegistrationSource === 'mobile_app'"
                (click)="filterByRegistrationSource('mobile_app')">
                {{'Mobile App'|translate}}
            </button>
        </div>
        <ngx-datatable
                #table
                class="material"
                [rows]="rows"
                [loadingIndicator]="loadingIndicator"
                [columnMode]="'force'"
                [headerHeight]="48"
                [footerHeight]="56"
                [rowHeight]="'auto'"
                [scrollbarH]="true"
                [reorderable]="reorderable"
                [selectionType]="'checkbox'"
                [externalPaging]="true"
                [count]="page.totalElements"
                [offset]="page.pageNumber"
                [limit]="page.size"
                (page)="setPage($event)"
                (sort)="sortResults($event)"
        >

<!--            <ngx-datatable-column [width]="48"-->
<!--                                  [canAutoResize]="false"-->
<!--                                  [sortable]="false">-->
<!--                <ng-template ngx-datatable-header-template let-value="value" let-allRowsSelected="allRowsSelected"-->
<!--                             let-selectFn="selectFn">-->
<!--                </ng-template>-->

<!--                <ng-template ngx-datatable-cell-template let-value="value" let-isSelected="isSelected"-->
<!--                             let-onCheckboxChangeFn="onCheckboxChangeFn">-->

<!--                </ng-template>-->
<!--            </ngx-datatable-column>-->


            <ngx-datatable-column name="{{'User'|translate}}" sortable="true" prop="id">
                <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>

                    <a appDisableRightClick appBlockCopyPaste *appIsGranted="['Customers', 'READ']" routerLink="/customers/details/{{row.id}}">{{row.firstName}} {{row.lastName}}</a>

                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="E-mail" prop="email">
                <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>

                    <a appDisableRightClick appBlockCopyPaste *appIsGranted="['Customers', 'READ']" routerLink="/customers/details/{{row.id}}">{{row.email}}</a>

                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column name="{{'Phone'|translate}}" prop="phone"></ngx-datatable-column>
            <ngx-datatable-column name="{{'Registered at'|translate}}" prop="createdAt">
                <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                    {{ row.createdAt|date: 'dd.MM.y HH:mm':'UTC+2': locale }}
                    <br/>
                    <span class="tag"
                          [ngClass]="{
                            'tag-manager': row.registrationSource === 'manager',
                            'tag-internet': row.registrationSource === 'internet_shop',
                            'tag-mobile': row.registrationSource === 'mobile_app'
                          }">
                        {{row.registrationSource|translate}}
                    </span>
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column name="{{'First traditional sale'|translate}}" prop="firstTraditionalTransaction">
                <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                    <span *ngIf="row.firstTraditionalTransaction">
                        {{ row.firstTraditionalTransaction|date: 'dd.MM.y HH:mm':'UTC+2': locale }}
                    </span>
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column name="{{'First online sale'|translate}}" prop="firstOnlineTransaction">
                <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                    <span *ngIf="row.firstOnlineTransaction">
                        {{ row.firstOnlineTransaction|date: 'dd.MM.y HH:mm':'UTC+2': locale }}
                    </span>
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="{{'Cards quantity'|translate}}" prop="cardsQuantity">
                <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                    <a appDisableRightClick class="nav-link" matRipple routerLink="/customers/cards/{{row.id}}" [routerLinkActive]="[]">
                        {{row.cardsQuantity}}
                    </a>
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="{{'Actions'|translate}}" sortable="false" prop="id">
                <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
<!--                    <a *appIsGranted="['Customers', 'READ']" routerLink="/pos/{{row.id}}">{{'Bill'|translate}}</a>&nbsp;-->
                    <a appDisableRightClick *appIsGranted="['Customers', 'READ']" routerLink="/customers/cards/{{row.id}}">{{'Cards'|translate}}</a>&nbsp;
                    <a appDisableRightClick *appIsGranted="['Customers', 'UPDATE']" routerLink="/customers/edit/{{row.id}}">{{'Edit'|translate}}</a>
                    <a appDisableRightClick *appIsGranted="['Customers', 'DELETE']"
                            class="mr-8"
                            aria-label="Delete"
                            style="color: red; cursor: pointer;"
                            (click)="showConfirmUserDeleteDialog(row)"
                    >
                        {{'Delete'|translate}}
                    </a>

                </ng-template>
            </ngx-datatable-column>
        </ngx-datatable>
    </div>
</div>
        </div>
    </div>
</div>
